import React from 'react'

import { useCountdown } from '@/hooks/countdown/useCountdown'

import { TTimerStaticProps } from './types'

export const TimerStatic = ({
  descriptionTimer,
  initialMinutes,
  interval,
  watchComponent: WatchComponent,
}: TTimerStaticProps): JSX.Element | null => {
  const { minutes, seconds } = useCountdown(initialMinutes)

  const formattedMinutes = minutes < 0 ? '00' : minutes.toString().padStart(2, '0')
  const formattedSeconds = seconds < 0 ? '00' : seconds.toString().padStart(2, '0')

  return (
    <div className={`timer-additional-container`}>
      <WatchComponent />
      <div className={`timer-description`}>{descriptionTimer}</div>
      <div className={`time`}>{`${formattedMinutes}:${formattedSeconds}`}</div>
      <div className="interval">{interval}</div>
    </div>
  )
}
